import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion";

const EXPERTISE = ["ESG", "Climate", "Environment", "Social Impact", "Governance", "Responsible Investment", "Reporting", "Training"];

export default function AboutBand() {
  return (
    <section className="bg-ink text-white sec" data-testid="about-section">
      <div className="wrap max-w-4xl">
        <Reveal>
          <h2 className="h-display font-bold text-[30px] sm:text-4xl lg:text-[52px] leading-[1.08]">
            Sustainability should improve the quality of decisions.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="text-mute text-[15.5px] sm:text-lg leading-relaxed mt-8 max-w-2xl">
            SarvaRitam brings together expertise across ESG, climate, environment, social impact, governance,
            responsible investment, reporting and training — helping organisations navigate complex expectations
            from regulators, investors and stakeholders.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="flex flex-wrap gap-x-6 gap-y-3 mt-9" data-testid="about-expertise-list">
            {EXPERTISE.map((e) => (
              <span key={e} className="flex items-center gap-2.5 text-[13.5px] font-semibold text-mute">
                <span className="w-1 h-1 rounded-full bg-gold" /> {e}
              </span>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.28}>
          <Link to="/about" className="btn-outline-gold mt-10" data-testid="about-cta">
            More About SarvaRitam <ArrowUpRight size={15} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
